export type TrackingCellType = 'user' | 'derived';
export const TRACKING_CLASS_USER = 'tracking-cell--user-changed';
export const TRACKING_CLASS_DERIVED = 'tracking-cell--derived';

const classNameCache = new Map<string, string>();

/**
 * Получение CSS класса для ячейки с подсветкой изменений
 * @param baseClassName - базовый класс ячейки
 * @param type - тип изменения: 'user' (ручное) или 'derived' (автоматическое)
 */
export function getTrackingClassName(
  baseClassName: string | undefined, 
  type: TrackingCellType = 'user'
): string {
  const trackingClass = type === 'derived' 
    ? TRACKING_CLASS_DERIVED 
    : TRACKING_CLASS_USER;
  
  const key = `${baseClassName || ''}:${type}`;
  
  if (classNameCache.has(key)) {
    return classNameCache.get(key)!;
  }
  
  const result = baseClassName 
    ? `${baseClassName} ${trackingClass}` 
    : trackingClass;
  
  classNameCache.set(key, result);
  return result;
}

export function clearClassNameCache(): void {
  classNameCache.clear();
}

